export default __webpack_public_path__ + "static/media/EV-share-mobile.4cae1174.png";